import type { SVGProps } from 'react'
const PinIconlyProIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 40 40" {...props}>
    <foreignObject width={55.052} height={37.373} x={-7.526} y={9.126}>
      <div
        style={{
          backdropFilter: 'blur(5.64px)',
          clipPath: 'url(#Pin_-_Iconly_Pro_svg__a)',
          height: '100%',
          width: '100%'
        }}
      />
    </foreignObject>
    <path
      fill="url(#Pin_-_Iconly_Pro_svg__b)"
      fillOpacity={0.75}
      fillRule="evenodd"
      d="M6.783 25.644 6.28 29.37v.004a2.95 2.95 0 0 0 2.916 3.35h21.61a2.95 2.95 0 0 0 2.917-3.35v-.004l-.505-3.726a3.164 3.164 0 0 0-3.138-2.742h-5.134a1.25 1.25 0 0 1 0-2.5h5.134a5.66 5.66 0 0 1 5.615 4.902v.003l.504 3.724v.002c.451 3.261-2.089 6.19-5.393 6.19H9.195c-3.304 0-5.844-2.93-5.393-6.19v-.002l.504-3.724a5.664 5.664 0 0 1 5.616-4.905h5.134a1.25 1.25 0 0 1 0 2.5H9.922a3.16 3.16 0 0 0-3.139 2.742"
      clipRule="evenodd"
      data-figma-bg-blur-radius={11.276}
    />
    <path
      fill="#2852E4"
      fillRule="evenodd"
      d="M26.93 20.401c1.31-1.946 2.255-4.206 2.255-6.482 0-5.05-4.117-9.167-9.183-9.167-5.067 0-9.184 4.117-9.184 9.167 0 2.276.945 4.536 2.254 6.482l1.983 2.523c1.932 2.08 4.013 3.445 4.947 3.445.931 0 3.013-1.365 4.945-3.445zm-4.028-6.549c0-1.6-1.3-2.9-2.9-2.9s-2.9 1.3-2.9 2.9 1.3 2.9 2.9 2.9 2.9-1.3 2.9-2.9"
      clipRule="evenodd"
    />
    <defs>
      <linearGradient
        id="Pin_-_Iconly_Pro_svg__b"
        x1={7.228}
        x2={26.661}
        y1={21.77}
        y2={43.834}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#5A81FF" stopOpacity={0.9} />
        <stop offset={0.447} stopColor="#567DFF" stopOpacity={0.955} />
        <stop offset={1} stopColor="#4E78FF" stopOpacity={0.9} />
      </linearGradient>
      <clipPath id="Pin_-_Iconly_Pro_svg__a">
        <path
          fillRule="evenodd"
          d="m14.31 16.517-.505 3.727v.004a2.95 2.95 0 0 0 2.916 3.35h21.61a2.95 2.95 0 0 0 2.917-3.35v-.004l-.505-3.726a3.164 3.164 0 0 0-3.138-2.742H32.47a1.25 1.25 0 0 1 0-2.5h5.135a5.66 5.66 0 0 1 5.615 4.902v.003l.504 3.723v.003c.451 3.26-2.09 6.19-5.393 6.19h-21.61c-3.304 0-5.844-2.93-5.393-6.19v-.003l.504-3.723a5.664 5.664 0 0 1 5.616-4.905h5.134a1.25 1.25 0 0 1 0 2.5h-5.134a3.16 3.16 0 0 0-3.139 2.741"
          clipRule="evenodd"
        />
      </clipPath>
    </defs>
  </svg>
)
export default PinIconlyProIcon
